function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgBell = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24pt",
    viewBox: "-21 0 24 24",
    height: "24pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.03940732
    },
    id: "path2",
    d: "m -0.65838478,11.333132 c -0.46411372,0 -0.84063872,-0.376525 -0.84063872,-0.840638 0,-2.3581287 -0.9180678,-4.574175 -2.585182,-6.2422134 -0.328651,-0.3286508 -0.328651,-0.8598801 0,-1.188685 0.3286511,-0.3286512 0.8600334,-0.3286512 1.1886853,0 1.98498952,1.9848363 3.07777342,4.6238957 3.07777342,7.4308984 0,0.464113 -0.3765251,0.840638 -0.840638,0.840638 z m 0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.03940732
    },
    id: "path4",
    d: "m -17.472229,11.333132 c -0.463959,0 -0.840638,-0.376525 -0.840638,-0.840638 0,-2.8070027 1.092937,-5.4460621 3.077773,-7.4308984 0.328651,-0.3286512 0.860035,-0.3286512 1.188686,0 0.328805,0.3288049 0.328805,0.8600342 0,1.188685 -1.667115,1.6671147 -2.585028,3.8840847 -2.585028,6.2422134 0,0.464113 -0.376679,0.840638 -0.840793,0.840638 z m 0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.03940732
    },
    id: "path6",
    d: "M -1.1803778,16.403438 C -2.4515723,15.328973 -3.1804537,13.75853 -3.1804537,12.094801 V 9.7509891 c 0,-2.9583201 -2.197575,-5.4072702 -5.0441378,-5.8175064 V 3.0254209 c 0,-0.4648835 -0.3766786,-0.8406383 -0.840639,-0.8406383 -0.464114,0 -0.840792,0.3757548 -0.840792,0.8406383 V 3.9334827 C -12.753355,4.3437189 -14.95016,6.792669 -14.95016,9.7509891 v 2.3438119 c 0,1.663729 -0.728882,3.234172 -2.007464,4.315257 -0.327112,0.280007 -0.514605,0.686857 -0.514605,1.117259 0,0.81139 0.659919,1.47131 1.47131,1.47131 h 13.8713784 c 0.8112372,0 1.47115582,-0.65992 1.47115582,-1.47131 0,-0.430402 -0.1874929,-0.837252 -0.52199302,-1.123879 z m 0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.03940732
    },
    id: "path8",
    d: "m -9.0652305,22.361333 c 1.522416,0 2.7960734,-1.085394 3.0887036,-2.522068 h -6.1774061 c 0.292476,1.436674 1.566133,2.522068 3.0887025,2.522068 z m 0,0"
  }));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBell, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bell.436e8d0d.svg";
export { ForwardRef as ReactComponent };